
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class LeaveTypeSelectGrid extends Serenity.EntityGrid<LeaveTypeRow, any> {
        protected getColumnsKey() { return 'HR.LeaveType'; }
        protected getDialogType() { return <any>LeaveTypeDialog; }
        protected getIdProperty() { return LeaveTypeRow.idProperty; }
        protected getLocalTextPrefix() { return LeaveTypeRow.localTextPrefix; }
        protected getService() { return LeaveTypeService.baseUrl; } 
        private rowSelection: Serenity.GridRowSelectionMixin;
      
        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected getColumns() {

            var _this = this;
            var columns = super.getColumns.call(this); 
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            columns = columns.filter(x => x.field != "Code");
            columns.forEach(column => {
                if (column.sourceItem && column.sourceItem.editLink)
                    column.format = undefined;
            });

            return columns;
        };
        get selectedItems(): LeaveTypeRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false; return true;

        }

    }

    export interface LeaveTypeelectOptions {
        ParentKey?: string;
        Key?: string;
        Title?: string;
        IsGroup?: boolean;
        GrantRevoke?: boolean;
    }
}